import React, { useState, useContext, useEffect } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Autocomplete,
  TextField,
  Slide,
  FormControlLabel,
  Switch,
  Box,
  CircularProgress,
  Grid,
} from "@mui/material";
import dayjs from "dayjs";
import "dayjs/locale/es";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DateTimeField } from "@mui/x-date-pickers/DateTimeField";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { esES as datePickersEsES } from "@mui/x-date-pickers/locales";
import { getTimestamp } from "../utils/mixin";
import GuardarTicketModal from "../components/GuardarTicketModal";
import { GlobalContext } from "../context/GlobalContext";
import {
  getTrucks,
  getBlocks,
  getBlocksLedesma,
  getDrivers,
  getMachines,
  getOrdenes,
  getMachinesLedesma,
  getProduct,
  getSupervisors,
  getSupervisorsLedesma,
} from "../API/autocompleteData";
import { saveNewTicket } from "../API/tickets";
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="left" ref={ref} {...props} timeout={500} />;
});

export default function NewTicket({}) {
  const { context, setContext } = useContext(GlobalContext);
  const [ticket, setTicket] = useState(null);
  const [trucks, setTrucks] = useState([]);
  const [drivers, setDrivers] = useState([]);
  const [blocks, setBlocks] = useState([]);
  const [supervisors, setSupervisors] = useState([]);
  const [machines, setMachines] = useState([]);
  const [selectedTruck, setSelectedTruck] = useState(null);
  const [selectedDriver, setSelectedDriver] = useState(null);
  const [selectedOperacionVenta, setSelectedOperacionVenta] = useState(null);
  const [selectedMachine, setSelectedMachine] = useState(null);
  const [selectedOdometer, setSelectedOdometer] = useState("");
  const [selectedOperation, setSelectedOperation] = useState(null);
  const [selectedBlock, setSelectedBlock] = useState(null);
  const [selectedSupervisor, setSelectedSupervisor] = useState(null);
  const [selectedCuarteo, setSelectedCuarteo] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [openModal, setOpenModal] = useState(false);
  const [inicio, setInicio] = useState(null);
  const [fin, setFin] = useState(null);
  const [entregaBruta, setEntregaBruta] = useState("");
  const [totInicial, setTotInicial] = useState("");
  const [totFinal, setTotFinal] = useState("");
  const [products, setProducts] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [urea, setUrea] = useState("");
  const [orders, setOrders] = useState([]);
  const [selectedOrden, setSelectedOrden] = useState(null);

  useEffect(() => {
    const fetchOrdenes = async () => {
      if (selectedOperacionVenta === "Tabacal" && selectedBlock?.BloqueID) {
        const todasLasOrdenes = await getOrdenes();
        console.log(todasLasOrdenes);
        const ordenesFiltradas = todasLasOrdenes.filter(
          (orden) => parseInt(orden.Bloque) === parseInt(selectedBlock.BloqueID)
        );
        setOrders(ordenesFiltradas);
      } else {
        setOrders([]);
      }
    };

    fetchOrdenes();
  }, [selectedBlock, selectedOperacionVenta]);

  useEffect(() => {
    const fetchData = async () => {
      const ticket = context.selectedTicket;
      setTicket(ticket);
      const trucks = await getTrucks();
      setTrucks(trucks);
      const foundTruck = trucks.find(
        (truck) => truck.Patente === ticket.patente
      );
      setSelectedTruck(foundTruck);

      const drivers = await getDrivers();
      setDrivers(drivers);
      const foundDriver = drivers.find(
        (driver) => driver.Legajo === ticket.choferLegajo
      );
      setSelectedDriver(foundDriver);

      setIsLoading(false);
      const products = await getProduct();
      setProducts(products);
    };

    fetchData();
  }, []);

  const changeOperacionVenta = async (operacion) => {
    let machines;
    let supervisors;
    let blocks;
    if (operacion == "Tabacal") {
      machines = await getMachines();
      setMachines(machines);
      supervisors = await getSupervisors();
      setSupervisors(supervisors);
      blocks = await getBlocks();
      setBlocks(blocks);
    }
    if (operacion == "Ledesma Capilar") {
      machines = await getMachinesLedesma();
      setMachines(machines);
      supervisors = await getSupervisorsLedesma();
      setSupervisors(supervisors);
      blocks = await getBlocksLedesma();
      setBlocks(blocks);
    }
  };
  const handleClose = () => {
    setContext({
      ...context,
      page: "listObs",
      selectedTicket: ticket,
    });
  };
  const startSendingProcess = () => {
    setOpenModal(true);
    saveTicket();
  };

  const saveTicket = async () => {
    const newTicket = ticket;
    newTicket.created = Date.now();
    newTicket.lat = null;
    newTicket.lng = null;
    newTicket.inicio = inicio ? inicio.format("DD/MM/YY HH:mm:ss") : "";
    newTicket.fin = fin ? fin.format("DD/MM/YY HH:mm:ss") : "";
    newTicket.estadoInicial = totInicial + " litros";
    newTicket.entregaBruta = entregaBruta + " litros";
    newTicket.estadoFinal = totFinal + " litros";
    newTicket.choferNombre = selectedDriver.Nombre;
    newTicket.choferLegajo = selectedDriver.Legajo;
    newTicket.patenteAuxilio = "";
    newTicket.producto = selectedProduct
      ? selectedProduct.CodigoProducto
      : "0104";
    newTicket.numeroVentaInt = parseInt(ticket.numeroVenta);
    newTicket.cliente = selectedOperacionVenta.split(" ").shift();
    if (selectedOperacionVenta === "Tabacal" && selectedOrden) {
      newTicket.gatec = selectedOrden.Gatec;
      newTicket.orden = selectedOrden.Orden;
      newTicket.operacionOrden = selectedOrden.Operacion;
      newTicket.operacionID = selectedOrden.OperacionID;
    }

    if (
      selectedOperacionVenta == "Tabacal" ||
      selectedOperacionVenta == "Ledesma Capilar"
    ) {
      newTicket.supervisorLegajo = selectedSupervisor.Legajo.toString();
      newTicket.supervisorNombre = selectedSupervisor.NombreyApellido;
      newTicket.bloqueID = selectedBlock.BloqueID.toString();
      newTicket.bloqueDescripcion = selectedBlock.Descripcion;
      newTicket.maquina = selectedMachine.MaquinaID;
      newTicket.operacion = selectedOperation;
      newTicket.horometro = selectedOdometer;
      newTicket.cuarteo = selectedCuarteo.toString();
    }
    if (selectedOperacionVenta == "Tabacal") {
      newTicket.urea = urea ? String(urea) : "0";
    }
    newTicket.operacionVenta = selectedOperacionVenta;
    newTicket.obs = "ok";
    await saveNewTicket(newTicket);
    handleClose();
  };

  const operacionesVenta = ["Tabacal", "Ledesma Tanques", "Ledesma Capilar"];
  const operations = ["Verde", "Quemada", "Otro"];

  return (
    <Dialog open={true} fullScreen fullWidth TransitionComponent={Transition}>
      {ticket != null && (
        <DialogTitle
          sx={{
            "@media print": {
              display: "none",
            },
          }}>
          Agregar Ticket {ticket.numeroVenta} - {ticket.patente}
        </DialogTitle>
      )}

      {isLoading ? (
        <Box
          sx={{ width: "100%", justifyContent: "center", textAlign: "center" }}>
          <CircularProgress />
        </Box>
      ) : (
        <DialogContent>
          <Autocomplete
            options={drivers}
            getOptionLabel={(option) => option.Nombre}
            value={selectedDriver}
            onChange={(event, newValue) => {
              setSelectedDriver(newValue);
            }}
            renderInput={(params) => (
              <TextField {...params} label="Chofer" margin="normal" />
            )}
          />
          <Autocomplete
            options={operacionesVenta}
            getOptionLabel={(option) => option}
            value={selectedOperacionVenta}
            sx={{ mt: -1 }}
            onChange={(event, newValue) => {
              setSelectedOperacionVenta(newValue);
              setSelectedOrden(null);
              changeOperacionVenta(newValue);
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Operacion de Venta"
                margin="normal"
              />
            )}
          />

          {selectedOperacionVenta != "Ledesma Tanques" &&
            selectedOperacionVenta != null && (
              <Box>
                <Autocomplete
                  options={machines}
                  getOptionLabel={(option) => option.Descripcion}
                  value={selectedMachine}
                  onChange={(event, newValue) => {
                    setSelectedMachine(newValue);
                  }}
                  renderInput={(params) => (
                    <TextField {...params} label="Máquina" margin="normal" />
                  )}
                />
                <TextField
                  label="Horómetro"
                  type="number"
                  InputProps={{ inputProps: { min: 0 } }}
                  value={selectedOdometer}
                  sx={{ marginY: 1, width: "100%" }}
                  onChange={(event) => {
                    setSelectedOdometer(event.target.value);
                  }}
                />

                <Autocomplete
                  options={blocks}
                  getOptionLabel={(option) => option.Descripcion}
                  value={selectedBlock}
                  onChange={(event, newValue) => {
                    setSelectedBlock(newValue);
                    setSelectedOrden(null);
                  }}
                  renderInput={(params) => (
                    <TextField {...params} label="Bloque" margin="normal" />
                  )}
                />
                {selectedOperacionVenta === "Tabacal" &&
                  Array.isArray(orders) && (
                    <Autocomplete
                      options={orders}
                      getOptionLabel={(option) =>
                        option ? `${option.Gatec} - ${option.Operacion}` : ""
                      }
                      value={selectedOrden}
                      onChange={(event, newValue) => {
                        setSelectedOrden(newValue);
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Orden de Servicio"
                          margin="normal"
                        />
                      )}
                    />
                  )}
                <Autocomplete
                  options={supervisors}
                  getOptionLabel={(option) => option.Descripcion}
                  value={selectedSupervisor}
                  onChange={(event, newValue) => {
                    setSelectedSupervisor(newValue);
                  }}
                  renderInput={(params) => (
                    <TextField {...params} label="Supervisor" margin="normal" />
                  )}
                />
                {selectedOperacionVenta == "Tabacal" && (
                  <Autocomplete
                    options={operations}
                    getOptionLabel={(option) => option}
                    value={selectedOperation}
                    onChange={(event, newValue) => {
                      setSelectedOperation(newValue);
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Operación"
                        margin="normal"
                      />
                    )}
                  />
                )}

                {selectedOperacionVenta == "Tabacal" && (
                  <>
                    <TextField
                      label="Urea"
                      type="number"
                      InputProps={{ inputProps: { min: 0, max: 80 } }}
                      value={urea}
                      sx={{ mt: 1, width: "100%" }}
                      onChange={(event) => {
                        const value = event.target.value;
                        const number = parseInt(value);

                        if (value === "" || (number >= 0 && number <= 80)) {
                          setUrea(value);
                        }
                      }}
                    />
                    <FormControlLabel
                      control={
                        <Switch
                          onChange={() => setSelectedCuarteo(!selectedCuarteo)}
                          checked={selectedCuarteo}
                        />
                      }
                      label="Cuarteo"
                    />
                  </>
                )}
              </Box>
            )}

          <Autocomplete
            options={products}
            getOptionLabel={(option) => option.DescripcionArticulo}
            value={selectedProduct}
            sx={{ mt: -1 }}
            onChange={(event, newValue) => {
              setSelectedProduct(newValue);
            }}
            renderInput={(params) => (
              <TextField {...params} label="Producto" margin="normal" />
            )}
          />
          <LocalizationProvider
            dateAdapter={AdapterDayjs}
            adapterLocale="es"
            localeText={
              datePickersEsES.components.MuiLocalizationProvider.defaultProps
                .localeText
            }>
            <Grid container>
              <Grid item xs={12} md={6}>
                <DateTimeField
                  label="Fecha Inicio"
                  value={inicio}
                  sx={{ mt: 1, ".MuiInputBase-root ": { padding: "8px" } }}
                  onChange={(newValue) => setInicio(newValue)}
                  format="DD/MM/YY HH:mm:ss"
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      size: "small",
                      placeholder: "dd/mm/aa hh:mm:ss",
                    },
                  }}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <DateTimeField
                  label="Fecha Fin"
                  value={fin}
                  sx={{ mt: 2, ".MuiInputBase-root ": { padding: "8px" } }}
                  onChange={(newValue) => setFin(newValue)}
                  format="DD/MM/YY HH:mm:ss"
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      size: "small",
                      placeholder: "dd/mm/aa hh:mm:ss",
                    },
                  }}
                />
              </Grid>
            </Grid>
          </LocalizationProvider>
          <TextField
            label="Entrega Bruta"
            type="number"
            InputProps={{ inputProps: { min: 0 } }}
            value={entregaBruta}
            sx={{ mt: 2, width: "100%" }}
            onChange={(event) => {
              setEntregaBruta(event.target.value);
            }}
          />
          <TextField
            label="Totalizador Inicial"
            type="number"
            InputProps={{ inputProps: { min: 0 } }}
            value={totInicial}
            sx={{ mt: 2, width: "100%" }}
            onChange={(event) => {
              setTotInicial(event.target.value);
            }}
          />
          <TextField
            label="Totalizador Final"
            type="number"
            InputProps={{ inputProps: { min: 0 } }}
            value={totFinal}
            sx={{ mt: 2, width: "100%" }}
            onChange={(event) => {
              setTotFinal(event.target.value);
            }}
          />
        </DialogContent>
      )}
      <DialogActions>
        <Button color="error" onClick={handleClose}>
          Cerrar
        </Button>
        <Button disabled={selectedDriver == null} onClick={startSendingProcess}>
          Guardar
        </Button>
      </DialogActions>
      <GuardarTicketModal isOpen={openModal} />
    </Dialog>
  );
}
